import type { PrimeVuePTOptions } from 'primevue/config';

import { cx } from '@/helpers/cva';

export default {
  bodyRow({ context, props }) {
    const evenClass = context.index % 2 === 0 ? 'even-row' : 'odd-row';

    return {
      class: cx('group group/body-row outline-none', evenClass, props?.pt?.['bodyRow']?.class),
    };
  },
  column: {
    bodyCell({ props }) {
      return {
        class: cx(
          'border-t border-[--v3-table-tableheaderborder] p-0 px-2 transition-colors py-3 group-hover:bg-[--v3-table-tableheaderbg]',
          (props)? props.pt?.['bodyCell']?.class : '',
        ),
      };
    },
    headerCell({ props }) {
      return {
        class: cx('py-0 align-top px-3 text-left border-t text-left relative border-t border-[--v3-table-tableheaderborder]', props?.pt?.['headerCell']?.class),
      };
    },
    headerContent: {
      class: 'min-h-12 flex items-center gap-x-4 p-0',
    },
    headerTitle: {
      class:
        'text-[10.5px] font-semibold uppercase text-[--v3-global-textsecondarycolor] whitespace-nowrap',
    },
    sort: {
      class: 'hidden',
    },
  },
  emptyMessage: {
    class: 'border-0 !bg-[--v3-surface-surface-100]',
  },
  wrapper: {
    class: 'overflow-visible',
  },
  emptyMessageCell: {
    class: 'bg-[transparent] p-0 border-0',
  },
  headerRow: 'group/header-row bg-[--color-brand-forrest-green-05]',
  table: {
    class: 'w-full !bg-[--v3-surface-surface-100]',
  },
} satisfies PrimeVuePTOptions['datatable'];
